module.exports = __webpack_public_path__ + "media/assets/icons/ic-settings-filled-7162a10643a9e0111405b01c56b6c8fa.svg";